var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { fetchCustomInspections, toggleActive } from '../services/customInspectionsService';
import { namespace } from '../constants';
const QUERY_KEYS = {
    all: ['customInspections'],
    list: () => ['customInspections', 'list']
};
const sortByActiveAndName = (items) => [...items].sort((a, b) => {
    var _a, _b;
    if (a.active !== b.active)
        return a.active ? -1 : 1;
    return ((_a = a.name) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.name) !== null && _b !== void 0 ? _b : '');
});
export function useCustomInspectionsQuery() {
    return useQuery({
        queryKey: QUERY_KEYS.list(),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const data = yield fetchCustomInspections();
            return sortByActiveAndName(data);
        })
    });
}
export function useToggleActiveMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: toggleActive,
        onSuccess: () => {
            toast.success(translate('toggle_active.success', { namespace }));
            void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.all });
        },
        onError: () => {
            toast.error(translate('toggle_active.failure', { namespace }));
        }
    });
}
export default function useCustomInspections(searchText) {
    const { data: customInspections = [], isLoading } = useCustomInspectionsQuery();
    const toggleMutation = useToggleActiveMutation();
    const [toggling, setToggling] = useState(null);
    const handleToggleActive = (id) => {
        setToggling(id);
        toggleMutation.mutate(id, {
            onSettled: () => setToggling(null)
        });
    };
    const filteredInspections = useMemo(() => {
        if (!searchText.trim())
            return customInspections;
        const lowerSearch = searchText.toLowerCase();
        return customInspections.filter((ci) => { var _a; return ((_a = ci.name) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(lowerSearch); });
    }, [customInspections, searchText]);
    return {
        customInspections: filteredInspections,
        loading: isLoading,
        toggling,
        handleToggleActive
    };
}
